export default "__VITE_ASSET__107c5533__"